import { render, staticRenderFns } from "./InsertTransferDetailsModalSection.vue?vue&type=template&id=cfb59a6e"
import script from "./InsertTransferDetailsModalSection.vue?vue&type=script&lang=js"
export * from "./InsertTransferDetailsModalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports